import Dropdown from "app/components/Dropdown";
import { CheckIcon, DropdownIcon } from "app/components/Icons";
import { sortOrder } from "app/types";
import clsx from "clsx";
import { MoveDown, MoveUp } from "lucide-react";
import React, { useState } from "react";

interface Props {
  onUpdate: (val) => void;
  value: string;
}
const OrderSelect: React.FC<Props> = ({ value, onUpdate }) => {
  const menus = [
    { label: "Ascending", value: sortOrder.ASC, icon:<MoveUp className=" size-4 text-secondary"/> },
    { label: "Descending", value: sortOrder.DESC, icon: <MoveDown  className=" size-4 text-secondary"/> },
  ];
  const [isOpen, setIsOpen] = useState(false);
  const menuItems = menus.map((opt) => {
    return {
      label: (
        <div
          className={`flex items-center justify-between gap-1.5 rounded-md transition-colors w-full `}
        >
         
          <div className="flex items-center gap-[4px] ">
            {opt.icon}
            <span className={`text-sm font-medium text-secondary`}>
              {opt.label}
            </span>
          </div>
          {opt.value === value && <CheckIcon color="#5A8DF1" size={20}/>}
        </div>
      ),
      action: () => onUpdate(opt.value),
    };
  });

  return (
    <div className=" relative">
      <Dropdown
        open={isOpen}
        setOpen={setIsOpen}
        trigger={
          <button
            className={clsx(
              " flex items-center justify-between w-full h-8 rounded border border-gray-200 text-secondary text-sm font-normal outline-none px-2 ",
              isOpen ? "border border-secondary " : ""
            )}
          >
            {value === sortOrder.ASC ? "Ascending" : "Descending"}
            <div
              className={`size-[16px] min-w-[16px] transition-transform duration-300 ease-in-out ${
                isOpen ? "rotate-180" : ""
              }`}
            >
              <DropdownIcon size={16} />
            </div>
          </button>
        }
        menuItems={menuItems}
        className="!w-[170px]"
      />
    </div>
  );
};

export default OrderSelect;
